const title = 'Pitchster Admin';

const email = 'contactus@pitchster.com';

const dateFormat = 'MMMM DD, YYYY';
const LOCALSTORAGE_KEYS = {
      token: 'token',
      refreshToken: 'refresh_token',
};
const loader = {
      minimumLoading: 700,
      delay: 100,
};

export { loader, dateFormat, email, title, LOCALSTORAGE_KEYS };
